import React from 'react';
import { motion } from 'framer-motion';

interface TextareaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  minHeight?: string;
}

const Textarea: React.FC<TextareaProps> = ({
  value,
  onChange,
  placeholder = '여기에 텍스트를 입력하거나 붙여넣으세요...',
  className = '',
  minHeight = '240px',
}) => {
  return (
    <motion.textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={`w-full p-24 bg-background rounded-large resize-none focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 transition-all ${className}`}
      style={{ minHeight, lineHeight: '1.6' }}
      whileFocus={{ scale: 1.01 }}
    />
  );
};

export default Textarea;
